import type { Cell } from '../../../services/intelligenceReport.service';
export const currency = (v: Cell | undefined) => v == null ? 'N/A' : Number(v).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
export const integer = (v: Cell | undefined) => v == null ? 'N/A' : Number(v).toLocaleString('en-US', { maximumFractionDigits: 0 });
export const decimal = (v: Cell | undefined) => v == null ? 'N/A' : Number(v).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
export const percent = (v: Cell | undefined) => v == null ? 'N/A' : `${decimal(v)}%`;
export const reportDate = (v: Cell | undefined) => {
  if (!v) return 'N/A';
  const [year, month, day] = String(v).slice(0, 10).split('-');
  return `${month}/${day}/${year}`;
};
